<template>
  <v-card style="margin:20px;padding:10px;" elevation="4">
    <div>{{ board.title }}</div>
    <v-text-field
      style="max-width:500px;"
      v-on:keydown="keydownNewEmail"
      label="enter e-mail"
      required
    ></v-text-field>
    <div style="width:100%">
      <v-card v-for="br in currentEmails" :key="br">
        <v-switch
          v-if="getUser().email !== br.email"
          label="is owner?"
          v-model="br.role"
          true-value="owner"
          false-value="participant"
          @change="updateLink(br)"
        />
        <v-btn @click="unlink(br)" v-if="getUser().email !== br.email">-</v-btn>
        {{ br.role }} - {{ br.email }}
      </v-card>
    </div>
  </v-card>
</template>

<script>
import * as api from "./api";

export default {
  name: "ShareBoard",
  components: {},
  props: {
    board: Object,
  },
  mounted() {
    console.log("sharing open");
    this.reloadSharing();
  },
  data: () => ({
    currentEmails: ["robertodifiore75@gmail.com"],
  }),
  computed: {},
  watch: {
    board: async function () {
      this.reloadSharing();
    },
  },
  methods: {
    async keydownNewEmail(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        await this.link(e.target.value);
      }
    },
    async updateLink(br) {
      await api.invite(this.board.id, br.email, br.role);
      this.reloadSharing();
    },
    async link(email) {
      await api.invite(this.board.id, email, "participant");
      this.reloadSharing();
    },
    async unlink(br) {
      if (br.role === "owner") {
        alert("cant kickout owner");
        return;
      }
      await api.kick(this.board.id, br.email);
      this.reloadSharing();
    },
    async reloadSharing() {
      this.currentEmails = await api.listSharing(this.board.id);
    },
    async keydown(e) {
      if (e.key === "Enter") {
        console.log("keydown", e);
      }
    },
    async delete(email) {
      console.log(email);
    },
  },
};
</script>
